/**
 * AllBaise Logo — "ALLBAISE" text logo.
 * Dark blue (#1e3a5f) in light mode, white in dark mode.
 */
export default function AllBaiseLogo({ size = 24, className = "" }) {
  return (
    <span
      className={`font-extrabold tracking-tight leading-none text-[#1e3a5f] dark:text-white ${className}`}
      style={{
        fontSize: `${Math.round(size * 0.7)}px`,
      }}
      aria-label="AllBaise"
    >
      ALL<span className="opacity-70">BAISE</span>
    </span>
  );
}
